import apiPdca from '../../../../helpers/apiPdca'
import { loading, loaded } from '../../../../layout/redux/layoutActions'

export const CHECK_FETCH_REQUEST = 'CHECK_FETCH_REQUEST'
export const CHECK_FETCH_SUCCESS = 'CHECK_FETCH_SUCCESS'
export const CHECK_FETCH_FAILURE = 'CHECK_FETCH_FAILURE'
export const CHECK_CLEAR = 'CHECK_CLEAR'

const normalizarTexto = valor => {
  if (typeof valor !== 'string') return ''
  return valor.trim()
}

const normalizarPlanos = planos => {
  if (!Array.isArray(planos)) {
    return []
  }

  return planos.map(item => ({
    id: item.idPlano,
    numeroPlano: item.numeroPlano,
    titulo: item.titulo,
    tipoPlano: item.tipo,
    ciclo: 'check',
    status: normalizarTexto(item.status),
    dataInicio: item.dataInicio,
    dataFinal: item.dataFinal,
    acaoExecutada: item.acaoExecutada,
    melhoriaPercentual: normalizarTexto(item.melhoriaPercentual),
    lojaNome: item.lojaNome,
    produtoNome: item.produtoNome
  }))
}

export const fetchCheck = ({ empresaId, projetoId, idiomaId, dataInicial, dataFinal }) => {
  return async dispatch => {
    dispatch({ type: CHECK_FETCH_REQUEST })
    dispatch(loading())

    try {
      const response = await apiPdca.post('/pdca/listaplanos', {
        empresaId,
        projetoId,
        idiomaId,
        tipoPlano: '',
        ciclo: 'check',
        dataInicial,
        dataFinal
      })

      const data = response?.data
      const planos = normalizarPlanos(data?.planos)

      dispatch({
        type: CHECK_FETCH_SUCCESS,
        payload: {
          itens: planos,
          total: planos.length,
          filtros: {
            dataInicial,
            dataFinal
          }
        }
      })
    } catch (error) {
      dispatch({
        type: CHECK_FETCH_FAILURE,
        payload: error?.message || 'Erro ao carregar planos do ciclo Check.'
      })
    } finally {
      dispatch(loaded())
    }
  }
}

export const clearCheck = () => ({
  type: CHECK_CLEAR
})